export default "__VITE_ASSET__CLVTJWKx__"